import React, { useRef } from 'react';
import LabelAction from '@meitu/saas-editor-ui/es/components/label-action';
import { ColorGroup } from '@meitu/xdesign-widgets';
import { useLocaleStore } from '@/i18n';
import { editor } from '@/instance';

export const StrokeFeature: React.FC<{
    id: string;
    stroke: string;
}> = React.memo(({ stroke, id }) => {
    const { $t } = useLocaleStore();
    const originVal = useRef<string | null>(null);

    return (
        <div className="c-qrcode-panel__item">
            <LabelAction title={$t((v) => v.panel.qrCodePanel.qrCodeColor)} align={true}>
                <ColorGroup
                    popupTriggerSize={{
                        width: 52,
                        height: 26,
                    }}
                    showIcon={false}
                    color={stroke}
                    setColor={(val) => {
                        if (originVal.current === null) {
                            originVal.current = stroke;
                        }
                        console.log('setColor val', val);
                        editor.qrCodeLayer.updateStyle(id, { stroke: val });
                    }}
                    setColorAfter={(val, __, { isBrandColor }) => {
                        if (isBrandColor) {
                            window._stat_track?.('hb_layers_func_use', {
                                func_id: '5_107',
                            });
                        }
                        if (originVal.current) {
                            console.log('setColorAfter val', val);
                            editor.qrCodeLayer.updateStyle(id, { stroke: val }, { writeHistory: true });
                        }
                        originVal.current = null;
                    }}
                    isGradient={true}
                    popupOverlayClassName="c-qrcode-panel__color-picker"
                    onToggleBizTab={(bizTab) => {
                        if (bizTab === 'team') {
                            window._stat_track?.('hb_layers_func_click', {
                                func_id: '5_107',
                            });
                        }
                    }}
                />
            </LabelAction>
        </div>
    );
});
